export default __webpack_public_path__ + "static/media/bag5.47b48fb9.png";